import { 
  LOGIN, LOGOUT, ADD_PROJECT, EDIT_PROJECT, DELETE_PROJECT, SET_PROJECTS, GET_PROJECTS, ADD_PROJECT_MEMBER, REMOVE_PROJECT_MEMBER, ADD_SCHEDULE, SET_SCHEDULE,
  EDIT_SCHEDULE, DELETE_SCHEDULE, ADD_ACTIVITY, SET_ACTIVITY, EDIT_ACTIVITY, DELETE_ACTIVITY, SET_ACTIVITIES, GET_SCHEDULE_ACTIVITIES, SET_SCHEDULE_ACTIVITIES,
  GET_PROJECT_SCHEDULES, SET_PROJECT_SCHEDULES, SET_PATH, SET_LOADING, SET_ALERT, SET_NAME, WEBSOCKET_CONNECTED, WEBSOCKET_DISCONNECTED, WEBSOCKET_AUTHORIZED,
  WEBSOCKET_CONNECTING, FETCH_DATA_PENDING, FETCH_DATA_COMPLETE, FETCH_DATA_FAIL, ADD_USER, EDIT_USER, DELETE_USER, SET_DELETE_PROJECT_DIALOGUE_ID,
  SET_DELETE_SCHEDULE_DIALOGUE_ID, SET_EDIT_PROJECT_DIALOGUE_ID, UUID, GET_SCHEDULE, CHANGE_PROJECT_MEMBER_ROLE, PUBLISH_SCHEDULE, UNPUBLISH_SCHEDULE,
  SET_PUBLISH_SCHEDULE_DIALOGUE_ID, SET_UNPUBLISH_SCHEDULE_DIALOGUE_ID, CLIENT_VERSION, UPDATE_CLIENT, Timestamp, SET_PROFILE_DIALOGUE_SHOWING,
  SET_NEW_SCHEDULE_DIALOGUE_ID, SET_GANON_VISIBLE, GET_PROJECT_CONTRACTORS, SET_PROJECT_CONTRACTORS, SiteboardApiValidator, SET_EDIT_CONTRACTORS_DIALOGUE_ID,
  SET_NEW_DAILY_REPORT_DIALOGUE_ID, ADD_DAILY_REPORT, GET_DAILY_REPORT_SUMMARIES, GET_DAILY_REPORT, SET_DELETE_DAILY_REPORT_DIALOGUE_ID, DELETE_DAILY_REPORT,
  SET_EDIT_DAILY_REPORT_DIALOGUE_ID, SET_PRIVACY_POLICY_DIALOGUE_OPEN, SET_TERMS_OF_USE_DIALOGUE_OPEN, SET_LAST_VIEWED_PROJECT, SET_FEEDBACK_DIALOGUE_OPEN,
  SET_IS_TOUCH_DEVICE, SUBMIT_FEEDBACK, SET_DARK_MODE, SET_ADMIN_DIALOGUE_OPEN, SEND_EMAIL, SET_SITEBOARD_EMAIL_ADDRESS, REQUEST_UPLOAD_DAILY_REPORT_IMAGE,
  FETCH_SCHEDULE_PDF, SET_LAST_INTERACTION_TIME, SET_SCHEDULE_MESSAGES_DIALOGUE_ID, ADD_SCHEDULE_MESSAGE_THREAD, GET_SCHEDULE_MESSAGE_THREADS, ADD_SCHEDULE_MESSAGE,
  ADD_UNREAD_SCHEDULE_MESSAGE_THREAD, ADD_ALL_UNREAD_SCHEDULE_MESSAGE_THREADS, ENTER_SCHEDULE_MESSAGE_THREAD, LEAVE_SCHEDULE_MESSAGE_THREAD,
  SET_UNREAD_MESSAGES_DIALOGUE_OPEN, GET_SCHEDULE_MESSAGES, SET_APP_FOCUSED, CHECK_LOGIN_CODE, ADD_ALL_SUBSCRIPTIONS, SET_WELCOME_DIALOGUE_OPEN,
  CREATE_STANDARD_SUBSCRIPTION_CHECKOUT, CREATE_STRIPE_PORTAL_SESSION, SET_UPGRADE_TO_STANDARD_DIALOGUE_OPEN, UserPreferences, CREATE_TRIAL_SUBSCRIPTION,
  CANCEL_PENDING_STANDARD_SUBSCRIPTION, SET_STARTUP_WELCOME_ENABLED, SET_SUBSCRIPTION_CHOOSER_DIALOGUE_OPEN, SET_EDIT_SUBSCRIPTION_MANAGERS_DIALOGUE_OPEN,
  ADD_SUBSCRIPTION_ADMIN, GET_SUBSCRIPTION_INVITES, SET_USER_ROLE_INFO_DIALOGUE_SHOWING, ACCEPT_SUBSCRIPTION_INVITE, REJECT_SUBSCRIPTION_INVITE,
  REMOVE_SUBSCRIPTION_ADMIN, REMOVE_PENDING_SUBSCRIPTION_ADMIN, CHANGE_PENDING_PROJECT_MEMBER_ROLE, REMOVE_PENDING_PROJECT_MEMBER, SET_USING_INVITE_LINK,
  STOP_USING_INVITE_LINK, SET_EDIT_PROJECT_MEMBERS_DIALOGUE_ID, LOAD_UPDATED_CLIENT, SET_JOINED_SUBSCRIPTION_DIALOGUE_SHOWING, ADD_PROJECT_SCHEDULE_CONTACTS,
  GET_PROJECT_SCHEDULE_CONTACTS, DELETE_PROJECT_SCHEDULE_CONTACT, SET_USING_INVITE_SUBSCRIPTION_CONTACT_LINK, STOP_USING_INVITE_SCHEDULE_CONTACT_LINK, Activity,
  ADD_TEMPORARY_ACTIVITY, REPLACE_TEMPORARY_ACTIVITY_ID, STOP_USING_UNSUBSCRIBE_SCHEDULE_CONTACT_LINK, SET_USING_UNSUBSCRIBE_SUBSCRIPTION_CONTACT_LINK,
  SET_DELETE_CONTACT_DIALOGUE_OPEN, SET_PROJECT_CONTACTS_DIALOGUE_ID, SETUP_LOCAL_SESSION, SET_SHARE_LINK_DIALOGUE_SHOWING, SET_USING_SHARE_SCHEDULE_LINK, 
  GET_SHARE_SCHEDULE_LINK, SET_EDIT_SCHEDULE_DIALOGUE_SHOWING, SET_REQUEST_SCHEDULE_EMAIL_UPDATES_DIALOGUE_OPEN, REQUEST_SCHEDULE_EMAIL_UPDATES,
  GET_CONTACT_SHARED_SCHEDULE_STATS, SET_CONFIRM_SHARE_SCHEDULE_WORK_DATES_DIALOGUE_OPEN, SET_SHARE_SCHEDULE_CONFIRMED, SET_REVIEW_SHARED_SCHEDULE_VIEWS_DIALOGUE_OPEN,
  SET_REVIEW_SHARED_SCHEDULE_CONFIRMATIONS_DIALOGUE_OPEN, SessionKey, PUSH_BROWSER_HISTORY_STATE, POP_BROWSER_HISTORY_STATE, PROMO_CODE_CREATE, PROMO_CODE_DELETE,
  PROMO_CODE_SET_NOTE, PROMO_CODE_SET_EXPIRATION, PROMO_CODE_FETCH_ALL, SET_DELETE_PROMO_CODE_DIALOGUE_OPEN, PROMO_CODE_SET_DISABLED, SET_NOTE_PROMO_CODE_DIALOGUE_OPEN,
  SET_EXPIRATION_PROMO_CODE_DIALOGUE_OPEN, SET_USING_PROMO_SIGNUP_LINK, STOP_USING_PROMO_SIGNUP_LINK, SET_PREFERS_PROJECTS_LIST_VIEW,
  SET_SCHEDULE_UNLOCKED_CONFIRMATION_SHOWING, SET_SCHEDULE_PUBLISHED_CONFIRMATION_SHOWING, SET_NEW_PROJECT_DIALOGUE_SHOWING,
} from './types';
import { isArray, isObject, getServerApiResponse, debugLog, uuidv4, } from '../Util';
import WebSocketUtility from '../WebSocketUtility';

let websocket = null;

// warn the user their update hasn't been saved if they try to leave the page before the server update
window.onbeforeunload = () => {
  let updatesPending = false;

  if(websocket !== null && websocket.hasPendingOptimisticUpdates()) {
    updatesPending = true;
  }

  if(updatesPending) {
    return "Are you sure you want to exit? Some changes are still being saved."; 
  }
};

export const connectWebsocket = (onSuccess) => (dispatch, getState) => {
  const onConnect = () => {
    dispatch({ type: WEBSOCKET_CONNECTED, payload: null, });

    // send authorization request
    const defaultErrorMessage = 'Error connecting, please reload the page';
    const onApiSuccess = (message) => {
      try {
        if(!isArray(message.projects) || !isArray(message.users) || typeof message.clientVersion !== 'string') throw new Error();
        let thisUser = null;
        let thisUserId = getState().localPersistent.userId;
        for(const user of message.users) {
          if(user.id === thisUserId) {
            thisUser = user;
            break;
          }
        }
        if(thisUser === null) throw new Error('Server did not send info for this user');

        // If there is a new client version available reload the browser with a query string to load it
        try {
          const newClientVersion = '' + Timestamp.validate(parseInt(message.clientVersion));
          if (newClientVersion !== CLIENT_VERSION && window.location.href.indexOf(newClientVersion) < 0) {
            window.location.href = '?v=' + newClientVersion;
            return;
          }
        } catch(error) {}

        if(typeof message.siteboardEmail === 'string') {
          dispatch({ type: SET_SITEBOARD_EMAIL_ADDRESS, payload: { email: message.siteboardEmail } });
        }

        if(isArray(message.subscriptions)) {
          dispatch({ type: ADD_ALL_SUBSCRIPTIONS, payload: message });
        }

        dispatch({ type: SET_PROJECTS, payload: message.projects });
        for(const user of message.users) {
          dispatch({ type: ADD_USER, payload: user });
        }
        if(isArray(message.subscriptionInvites)) {
          dispatch({ type: GET_SUBSCRIPTION_INVITES, payload: message });
        }
        if(isArray(message.unreadScheduleMessageThreads)) {
          dispatch({ type: ADD_ALL_UNREAD_SCHEDULE_MESSAGE_THREADS, payload: message });
        }
        if(UserPreferences.isValid(message.userPreferences)) {
          if(message.userPreferences.showWelcomeScreen === true) {
            dispatch(siteboardAction(SET_WELCOME_DIALOGUE_OPEN, { isOpen: true }));
          }
          dispatch({ type: SET_STARTUP_WELCOME_ENABLED, payload: { userPreferences: message.userPreferences}}); // TODO: make a websocket connect action to do this
          dispatch({ type: SET_DARK_MODE, payload: { userPreferences: message.userPreferences}}); // TODO: make a websocket connect action to do this
        }

        dispatch({ type: WEBSOCKET_AUTHORIZED, payload: { userId: getState().localPersistent.userId }, });
        websocket.setAuthorized(true);
        try { onSuccess() } catch(error) {}
      } catch(error) {
        onApiError();
      }
    };
    const onApiError = (message) => {
      debugLog(message);
      dispatch({ type: LOGOUT, payload: null });
      //dispatch(setAlert(typeof message.payload === 'string' ? message.payload : defaultErrorMessage));
    };
    websocket.send({
      type: LOGIN,
      userId: getState().localPersistent.userId,
      sessionKey: getState().localPersistent.sessionKey,
      clientVersion: CLIENT_VERSION,
    }, onApiSuccess, onApiError);
  };
  const onMessage = (message) => {
    try {
      if((message.type === SET_PATH && typeof message.payload === 'string')
      || (message.type === SET_ALERT && typeof message.payload === 'string')
      || (message.type === SET_PROJECTS && isArray(message.payload))
      || (message.type === SET_ACTIVITIES && isArray(message.payload))
      || (message.type === ADD_USER && isObject(message.payload))
      || (message.type === EDIT_USER && isObject(message.payload))
      || (message.type === DELETE_USER && isObject(message.payload))
      || (message.type === UPDATE_CLIENT && typeof message.payload === 'string')
      ) {
        dispatch({ type: message.type, payload: message.payload });
      } else if(message.type === LOGOUT) {
        dispatch({ type: message.type, payload: null });
      } else if(message.type === LOAD_UPDATED_CLIENT) {
        try {
          const newClientVersion = '' + Timestamp.validate(parseInt(message.payload.newClientVersion));
          if (newClientVersion !== CLIENT_VERSION && window.location.href.indexOf(newClientVersion) < 0) {
            window.location.href = '?v=' + newClientVersion;
          }
        } catch(error) {}
      } else if(typeof message.type === 'undefined') {
      } else {
        // Dispatch the message if it is a siteboard action with valid data
        if(!(message.type in SiteboardApiValidator)) throw new Error('Could not find validator for ' + message.type);
        const validOutput = SiteboardApiValidator[message.type].validateOutput(message); // assert that the message object contains valid date for the type
        dispatch({ type: message.type, payload: validOutput });
      }
    } catch(error) {
      debugLog('websocket onMessage: ', error); 
    }
  };

  if(websocket !== null) {
    websocket.disconnect();
  }

  if(!UUID.isValid(getState().localPersistent.userId) || !SessionKey.isValid(getState().localPersistent.sessionKey)) {
    return;
  }

  dispatch({ type: WEBSOCKET_CONNECTING, payload: null, });
  websocket = new WebSocketUtility('wss://'+process.env.REACT_APP_WEBSOCKET_URL, {
    onMessage: onMessage,
    onConnect: onConnect,
    onDisconnect: () => { dispatch({ type: WEBSOCKET_DISCONNECTED, payload: null, }); },
    onError: (error) => { debugLog(error); },
  });
};
export const disconnectWebsocket = () => dispatch => {
  if(websocket !== null) {
    websocket.disconnect();
  }
}

export const login = (user, sessionKey, onSuccess) => dispatch => {
  dispatch({ type: ADD_USER, payload: user });
  dispatch({
    type: LOGIN,
    payload: {
      userId: user.id,
      sessionKey: sessionKey,
    }
  });
  dispatch(connectWebsocket(onSuccess));
};
export const logout = () => (dispatch, getState) => {
  dispatch(setLoading('Logging out'));
  const onApiSuccess = (data) => {
    dispatch(setLoading(''));
    try {
      dispatch({ type: LOGOUT, payload: null });
      dispatch(disconnectWebsocket());
    } catch(error) {
      onApiError();
    }
  };
  const onApiError = (errorMessage) => {
    // log out even if there is an error so the user has a change to refresh their session
    dispatch(setLoading(''));
    dispatch({ type: LOGOUT, payload: null });
    dispatch(disconnectWebsocket());
    //dispatch(setAlert(typeof errorMessage === 'string' ? errorMessage : 'There was an error logging you out. Please try again in a moment or reload the page if the problem continues.'));
  };
  getServerApiResponse({
    action: LOGOUT,
    userId: getState().localPersistent.userId,
    sessionKey: getState().localPersistent.sessionKey,
  }, onApiSuccess, onApiError);
};

export const setLoading = (message) => dispatch => { dispatch({ type: SET_LOADING, payload: { message: message} }); };
export const setAlert = (message) => dispatch => { dispatch({ type: SET_ALERT, payload: message }); };
export const setPath = (path) => (dispatch, getState) => {
  dispatch({ type: SET_PATH, payload: path });

  // If there is a new client version available reload the browser with a query string to load it
  // This is a good time to do this because we know the user isn't in the middle of some other action
  try {
    const newClientVersion = '' + Timestamp.validate(parseInt(getState().localEphemeral.newClientVersion));
    if (newClientVersion !== CLIENT_VERSION && window.location.href.indexOf(newClientVersion) < 0) {
      window.location.href = '?v=' + newClientVersion;
    }
  } catch(error) {}
};

export const redeemLoginCode = (params, isFromUrl) => (dispatch, getState) => {
  dispatch(setLoading(params.loadingMessage));
  const onApiSuccess = (data) => {
    dispatch(setLoading(''));
    try {
      if(!isObject(data.user) || !SessionKey.isValid(data.sessionKey)) throw new Error();
      dispatch(login(data.user, data.sessionKey)); 
      if(isFromUrl === true) {
        window.history.pushState('', '', '?'); // clear the url
      }
    } catch(error) {
      onApiError();
    }
  };
  const onApiError = (errorMessage) => {
    dispatch(setLoading(''));
    if(isFromUrl === true) {
      window.history.pushState('', '', '?'); // clear the url
      if (getState().localPersistent.isLoggedIn === true) {
        dispatch(connectWebsocket()); // TODO: are we possibly connecting twice here?
      } else {
        dispatch(setAlert(typeof errorMessage === 'string' ? errorMessage : params.defaultErrorMessage));
      }
    } else {
      dispatch(setAlert(typeof errorMessage === 'string' ? errorMessage : params.defaultErrorMessage));
    }
  };
  getServerApiResponse(params, onApiSuccess, onApiError);
};

const Thunks = {};
//Thunks[EDIT_PROJECT] = (validInput, dispatch, getState, onSuccess) => {
//  //// dont't allow updating if we are not connected to the server
//  //if(getState().localEphemeral.websocketState !== WEBSOCKET_AUTHORIZED) {
//  //  dispatch(setAlert('You are not connected to ' + process.env.REACT_APP_WEBSITE_NAME + '. Reload the page or reconnect your internet.'));
//  //  return;
//  //}
//
//  //// find stored item and make a deep copy to use as a rollback if the server update fails
//  //let storedProject = null;
//  //for(const item of (getState().serverSynced.projects || [])) {
//  //  if(item.id === project.id) {
//  //    storedProject = {
//  //      ...item, 
//  //      members: {...item.members},
//  //      schedules: {...item.schedules},
//  //    };
//  //    break;
//  //  }
//  //}
//  //if (storedProject === null) return;
//
//  //const apiUpdateMessage = { type: EDIT_PROJECT, userId: getState().localPersistent.userId, project: project };
//  //const updateFunction = (item) => dispatch({ type: EDIT_PROJECT, payload: item }); 
//  //const getItemFromSuccessResponseFunction = (message) => message.project; 
//  //const onApiSuccess = (message) => {};
//  //const onApiError = (message) => dispatch(setAlert('Error Editing Project'));
//  //websocket.optimisticUpdateWithDebounce(storedProject, project, updateFunction, getItemFromSuccessResponseFunction, apiUpdateMessage, onApiSuccess, onApiError);
//};
Thunks[EDIT_SCHEDULE] = (validInput, dispatch, getState, onSuccess) => {
  if(getState().serverSynced.localOnlyMode === true) {
    dispatch({ type: EDIT_SCHEDULE, payload: validInput, });
    setTimeout(() => {
      try { onSuccess(validInput); } catch(error) {}
    }, 1);
    return;
  }

  // dont't allow updating if we are not connected to the server
  if(getState().localEphemeral.websocketState !== WEBSOCKET_AUTHORIZED) { // TODO: put this into websocket
    dispatch(setAlert('You are not connected to ' + process.env.REACT_APP_WEBSITE_NAME + '. Reload the page or reconnect your internet.'));
    return;
  }

  // find stored item and make a deep copy to use as a rollback if the server update fails
  const storedSchedule = getState().serverSynced.schedules[validInput.schedule.id];
  if(storedSchedule === undefined) return;
  const savedSchedule = {
    ...storedSchedule, 
    activitiesOrder: [...(isArray(storedSchedule.activitiesOrder) ? storedSchedule.activitiesOrder : [])],
    weatherDates: {...storedSchedule.weatherDates},
    holidayDates: {...storedSchedule.holidayDates},
  };

  const updateFunction = (item) => dispatch({ type: EDIT_SCHEDULE, payload: { schedule: item }}); 
  const getItemFromSuccessResponseFunction = (message) => message.schedule; 
  const onApiSuccess = (message) => {};
  const onApiError = (message) => dispatch(setAlert(message.payload || 'Error Editing Schedule'));
  websocket.optimisticUpdateWithDebounce(savedSchedule, validInput.schedule, updateFunction, getItemFromSuccessResponseFunction, validInput, onApiSuccess, onApiError);
}
Thunks[DELETE_SCHEDULE] = (validInput, dispatch, getState, onSuccess) => {
  //export const deleteSchedule = (schedule, onSuccess) => (dispatch, getState) => 
  dispatch(setLoading('Deleting Schedule'));
  const defaultErrorMessage = 'Error Deleting Schedule';
  const onApiSuccess = (message) => {
    dispatch(setLoading('')); 
    try {
      const validOutput = SiteboardApiValidator[DELETE_SCHEDULE].validateOutput(message);
      dispatch({ type: DELETE_SCHEDULE, payload: validOutput});
      try { onSuccess(message); } catch(error) {}
    } catch(error) {
      dispatch(setAlert(defaultErrorMessage));
    }
  };
  const onApiError = (message) => {
    dispatch(setLoading(''));
    dispatch(setAlert(typeof message.payload === 'string' ? message.payload : defaultErrorMessage));
  };
  const localDeleteFunction = (item) => {}; 
  const localUndeleteFunction = (item) => {}; 
  const existingSchedule = getState().serverSynced.schedules[validInput.scheduleId];

  // Using optimistic delete here because we use optimistic update for the schedule, but we're going to let the server complete the deletion before we do it locally
  websocket.optimisticDelete(existingSchedule, localDeleteFunction, localUndeleteFunction, validInput, onApiSuccess, onApiError);
}
Thunks[PUBLISH_SCHEDULE] = (validInput, dispatch, getState, onSuccess) => {
  //export const publishSchedule = (schedule, onSuccess) => (dispatch, getState) => 
  if(websocket !== null && websocket.hasPendingOptimisticUpdates()) {
    dispatch(setAlert('Please try again in a few seconds, your recent edits are being saved'));
    return;
  }

  const defaultErrorMessage = 'Error Sending Schedule';
  dispatch(setLoading('Sending Schedule'));
  const onApiSuccess = (message) => {
    dispatch(setLoading('')); 
    try {
      const validOutput = SiteboardApiValidator[PUBLISH_SCHEDULE].validateOutput(message);
      dispatch({ type: PUBLISH_SCHEDULE, payload: validOutput});
      try { onSuccess(message); } catch(error) {}
    } catch(error) {
      dispatch(setAlert(defaultErrorMessage));
    }
  };
  const onApiError = (message) => {
    dispatch(setLoading(''));
    dispatch(setAlert(typeof message.payload === 'string' ? message.payload : defaultErrorMessage));
  };
  websocket.send(validInput, onApiSuccess, onApiError);
}

Thunks[ADD_ACTIVITY] = (validInput, dispatch, getState, onSuccess) => {
  if(getState().serverSynced.localOnlyMode === true) {
    dispatch({ type: ADD_ACTIVITY, payload: validInput, });
    setTimeout(() => {
      try { onSuccess(validInput); } catch(error) {}
    }, 1);
    return;
  }

  if(getState().localEphemeral.websocketState !== WEBSOCKET_AUTHORIZED) {
    dispatch(setAlert('You are not connected to ' + process.env.REACT_APP_WEBSITE_NAME + '. Reload the page or reconnect your internet.'));
    return;
  }

  // create temporary activity
  const temporaryActivity = Activity.validate({
    ...validInput.activity,
    id: uuidv4(),
  });
  dispatch({ 
    type: ADD_TEMPORARY_ACTIVITY,
    payload: { activity: temporaryActivity },
  });

  const onApiSuccess = (message) => {
    try {
      const validOutput = SiteboardApiValidator[ADD_ACTIVITY].validateOutput(message);
      if(!(temporaryActivity.id in getState().serverSynced.activities)) {
        // temporary activity has been deleted. delete it on server too
        websocket.send({
          type: DELETE_ACTIVITY, 
          userId: getState().serverSynced.userId,
          activityId: validOutput.activity.id,
          scheduleId: validOutput.activity.scheduleId,
          projectId: validOutput.activity.projectId,
          subscriptionId: getState().serverSynced.projects[validOutput.activity.projectId].subscriptionId,
        });
      } else {
        // replace temporary activity
        dispatch({ type: REPLACE_TEMPORARY_ACTIVITY_ID, payload: {
          temporaryActivityId: temporaryActivity.id,
          serverGeneratedId: validOutput.activity.id,
        }});
        onSuccess({activity: getState().serverSynced.activities[validOutput.activity.id]}); 
        // send updates to server
        dispatch(siteboardAction(EDIT_ACTIVITY, {
          subscriptionId: getState().serverSynced.projects[validOutput.activity.projectId].subscriptionId,
          activity: getState().serverSynced.activities[validOutput.activity.id],
        }));
      }
      //dispatch({ type: ADD_ACTIVITY, payload: validOutput });
    } catch(error) {
      dispatch(setAlert(error.message));
    }
  };
  const onApiError = (message) => {
    dispatch({ type: DELETE_ACTIVITY, payload: { activityId: temporaryActivity.id } })
    dispatch(setAlert(isObject(message) && typeof message.payload === 'string' && message.payload.length > 0 ? message.payload : ('Error Adding Activity')));
  };
  websocket.send({
    ...validInput,
    type: ADD_ACTIVITY, 
    userId: getState().serverSynced.userId,
  }, onApiSuccess, onApiError);
  try { onSuccess({activity: temporaryActivity, isTemporary: true}); } catch(error) {}
};
Thunks[EDIT_ACTIVITY] = (validInput, dispatch, getState, onSuccess) => {
  if(getState().serverSynced.localOnlyMode === true) {
    dispatch({ type: EDIT_ACTIVITY, payload: validInput, });
    setTimeout(() => {
      try { onSuccess(validInput); } catch(error) {}
    }, 1);
    return;
  }

  // update locally only if its a temporary activity
  if(validInput.activity.id in getState().serverSynced.temporaryActivityIds) {
    dispatch({ type: EDIT_ACTIVITY, payload: { activity: validInput.activity }})
    return;
  }

  // dont't allow updating if we are not connected to the server
  if(getState().localEphemeral.websocketState !== WEBSOCKET_AUTHORIZED) {
    dispatch(setAlert('You are not connected to ' + process.env.REACT_APP_WEBSITE_NAME + '. Reload the page or reconnect your internet.'));
    return;
  }

  // find stored item (its state before the user change) and make a deep copy to use as a rollback if the server update fails
  const storedActivity = getState().serverSynced.activities[validInput.activity.id];
  if (storedActivity === undefined) return;
  const savedActivity = {
    ...storedActivity,
    activeDates: {...storedActivity.activeDates}
  };

  // TODO: maybe handle when parent items like the schedule and project are deleted then a pending update is sent
 
  const updateFunction = (item) => dispatch({ type: EDIT_ACTIVITY, payload: { activity: item }}); 
  const getItemFromSuccessResponseFunction = (message) => message.activity; 
  const onApiSuccess = (message) => {};
  const onApiError = (message) => dispatch(setAlert(message.payload || 'error editing activity'));
  websocket.optimisticUpdateWithDebounce(savedActivity, validInput.activity, updateFunction, getItemFromSuccessResponseFunction, validInput, onApiSuccess, onApiError);
}
Thunks[DELETE_ACTIVITY] = (validInput, dispatch, getState, onSuccess) => {
  if(getState().serverSynced.localOnlyMode === true) {
    dispatch({ type: DELETE_ACTIVITY, payload: validInput, });
    setTimeout(() => {
      try { onSuccess(validInput); } catch(error) {}
    }, 1);
    return;
  }

  // delete locally only if its a temporary activity
  if(validInput.activityId in getState().serverSynced.temporaryActivityIds) {
    dispatch({ type: DELETE_ACTIVITY, payload: { activityId: validInput.activityId } })
    return;
  }

  const defaultErrorMessage = 'Error Deleting Activity';
  // TODO: only send projectId, scheduleId, activityid for the DELETE_ACTIVITY request
  
  const storedActivity = getState().serverSynced.activities[validInput.activityId];
  const localDeleteFunction = (item) => dispatch({ type: DELETE_ACTIVITY, payload: { activityId: item.id } }); 
  const localUndeleteFunction = (item) => dispatch({ type: ADD_ACTIVITY, payload: { activity: item } }); 
  const onApiSuccess = (message) => { try { onSuccess(message); } catch(error) {} };
  const onApiError = (message) => dispatch(setAlert(typeof message.payload === 'string' ? message.payload : defaultErrorMessage));
  websocket.optimisticDelete(storedActivity, localDeleteFunction, localUndeleteFunction, validInput, onApiSuccess, onApiError);
}
Thunks[REQUEST_UPLOAD_DAILY_REPORT_IMAGE] = (validInput, dispatch, getState, onSuccess) => {
  const defaultErrorMessage = 'Error Requesting to Upload Daily Report Worksite Picture';
  //dispatch(setLoading('Sending Email'));
  const onApiSuccess = (message) => {
    try {
      //dispatch(setLoading('')); 
      const validOutput = SiteboardApiValidator[REQUEST_UPLOAD_DAILY_REPORT_IMAGE].validateOutput(message);
      try { onSuccess(validOutput); } catch(error) {}
    } catch(error) {
      onApiError(error);
    }
  };
  const onApiError = (message) => {
    debugLog(message || defaultErrorMessage);
    //dispatch(setLoading(''));
    //dispatch(setAlert(typeof message.payload === 'string' ? message.payload : defaultErrorMessage));
  };
  websocket.send(validInput, onApiSuccess, onApiError);
};
Thunks[SET_DARK_MODE] = (validInput, dispatch, getState, onSuccess) => {
  if(getState().serverSynced.localOnlyMode === true) {
    dispatch({ 
      type: SET_DARK_MODE, 
      payload: {
        userPreferences: UserPreferences.validate({
          userId: validInput.userId,
          showWelcomeScreen: false,
          darkMode: validInput.enabled,
        }) 
      }});
    return;
  }

  // find stored item (its state before the user change) and make a deep copy to use as a rollback if the server update fails
  const userPreferences = getState().serverSynced.userPreferences;
  if (userPreferences === undefined) return;
  const savedUserPreferences = { ...userPreferences, };
  const newUserPreferences = {
    ...userPreferences,
    darkMode: validInput.enabled,
  };

  const updateFunction = (item) => dispatch({ type: SET_DARK_MODE, payload: { userPreferences: item }}); 
  const getItemFromSuccessResponseFunction = (message) => message.userPreferences; 
  const onApiSuccess = (message) => {};
  const onApiError = (message) => dispatch(setAlert(message.payload || 'error updating dark mode preference'));
  websocket.optimisticUpdateWithDebounce(savedUserPreferences, newUserPreferences, updateFunction, getItemFromSuccessResponseFunction, validInput, onApiSuccess, onApiError);
}
Thunks[FETCH_SCHEDULE_PDF] = (validInput, dispatch, getState, onSuccess) => {
  if(websocket !== null && websocket.hasPendingOptimisticUpdates()) {
    dispatch(setAlert('Please try again in a few seconds, your recent edits are being saved'));
    return;
  }

  dispatch(setLoading('Generating Schedule PDF'));
  const onApiSuccess = (data) => {
    dispatch(setLoading(''));
    try {
      const validOutput = SiteboardApiValidator[FETCH_SCHEDULE_PDF].validateOutput(data);
      onSuccess(validOutput.pdfBase64);
    } catch(error) {
      onApiError(error);
    }
  };
  const onApiError = (errorMessage) => {
    dispatch(setLoading(''));
    dispatch(setAlert(typeof errorMessage === 'string' ? errorMessage : 'Error Generating Schedule PDF'));
  };
  getServerApiResponse({
    ...validInput,
    action: FETCH_SCHEDULE_PDF, 
  }, onApiSuccess, onApiError);
};

Thunks[SET_APP_FOCUSED] = (validInput, dispatch, getState) => {
  // Reload the browser if the websocket has gone stale due to the app being suspended
  if(validInput.isFocused === true && window && websocket !== null && websocket.isStale()) {
    debugLog('reloading because websocket is stale');
    window.location.reload();
  };

  dispatch({ type: SET_APP_FOCUSED, payload: validInput}); 
};

Thunks[PUSH_BROWSER_HISTORY_STATE] = (validInput, dispatch, getState, onSuccess) => {
  const stateId = uuidv4();
  const popStateListenerAdded = getState().localEphemeral.browserHistoryPopStateListenerAdded;

  if(!popStateListenerAdded) {
    window.history.replaceState({id: null, index: getState().localEphemeral.browserHistoryStackCounter}, '');
  }

  dispatch({ type: PUSH_BROWSER_HISTORY_STATE, payload: validInput }); 
  window.history.pushState({id: stateId, index: getState().localEphemeral.browserHistoryStackCounter}, "", validInput.url.length === 0 ? ' ' : validInput.url);

  if(!popStateListenerAdded) {
    window.addEventListener("popstate", (event) => {
      const hash = window.location.hash;
      if(!isObject(event.state) || (!('index' in event.state) || (typeof event.state.index === 'number' && event.state.index < getState().localEphemeral.browserHistoryStackCounter))) {
        console.log('PAGE BACK');
        dispatch({ type: POP_BROWSER_HISTORY_STATE, payload: {} }); 
        window.history.pushState({id: null, index: null}, ''); // clear history after this point
        window.history.back();
      }
    });
  }

  try {
    onSuccess({stateId: stateId});
  } catch(error) {}
};

export const setDeleteDialogeProjectId = (projectId) => dispatch => { dispatch({ type: SET_DELETE_PROJECT_DIALOGUE_ID, payload: projectId }); };
export const setDeleteScheduleDialogueId = (scheduleId) => dispatch => { dispatch({ type: SET_DELETE_SCHEDULE_DIALOGUE_ID, payload: scheduleId }); };
export const setPublishScheduleDialogueId = (scheduleId) => dispatch => { dispatch({ type: SET_PUBLISH_SCHEDULE_DIALOGUE_ID, payload: scheduleId }); };
export const setUnpublishScheduleDialogueId = (scheduleId) => dispatch => { dispatch({ type: SET_UNPUBLISH_SCHEDULE_DIALOGUE_ID, payload: scheduleId }); };
export const setProfileDialogueShowing = (isShowing) => dispatch => { dispatch({ type: SET_PROFILE_DIALOGUE_SHOWING, payload: isShowing }); };
export const setNewScheduleDialogueId = (projectId, scheduleId) => dispatch => {
  dispatch({ type: SET_NEW_SCHEDULE_DIALOGUE_ID, payload: { projectId: projectId, scheduleId: scheduleId, }});
};
export const setGanonVisible = (isShowing) => dispatch => { dispatch({ type: SET_GANON_VISIBLE, payload: isShowing}); };

Thunks[SET_NEW_PROJECT_DIALOGUE_SHOWING] = (validInput, dispatch, getState) => { dispatch({ type: SET_NEW_PROJECT_DIALOGUE_SHOWING, payload: validInput }); };
Thunks[SET_EDIT_PROJECT_DIALOGUE_ID] = (validInput, dispatch, getState) => { dispatch({ type: SET_EDIT_PROJECT_DIALOGUE_ID, payload: validInput }); };
Thunks[SET_DELETE_PROJECT_DIALOGUE_ID] = (validInput, dispatch, getState) => { dispatch({ type: SET_DELETE_PROJECT_DIALOGUE_ID, payload: validInput.projectId }); };
Thunks[SET_EDIT_PROJECT_MEMBERS_DIALOGUE_ID] = (validInput, dispatch, getState) => { dispatch({ type: SET_EDIT_PROJECT_MEMBERS_DIALOGUE_ID, payload: validInput}); };
Thunks[SET_EDIT_CONTRACTORS_DIALOGUE_ID] = (validInput, dispatch, getState) => { dispatch({ type: SET_EDIT_CONTRACTORS_DIALOGUE_ID, payload: validInput.projectId }); };
Thunks[SET_NEW_DAILY_REPORT_DIALOGUE_ID] = (validInput, dispatch, getState) => { dispatch({ type: SET_NEW_DAILY_REPORT_DIALOGUE_ID, payload: validInput.projectId }); };
Thunks[SET_DELETE_DAILY_REPORT_DIALOGUE_ID] = (validInput, dispatch, getState) => { dispatch({ type: SET_DELETE_DAILY_REPORT_DIALOGUE_ID, payload: validInput.dailyReportId }); };
Thunks[SET_SCHEDULE_MESSAGES_DIALOGUE_ID] = (validInput, dispatch, getState) => { dispatch({ type: SET_SCHEDULE_MESSAGES_DIALOGUE_ID, payload: validInput }); };
Thunks[SET_PRIVACY_POLICY_DIALOGUE_OPEN] = (validInput, dispatch, getState) => { dispatch({ type: SET_PRIVACY_POLICY_DIALOGUE_OPEN, payload: validInput}); };
Thunks[SET_TERMS_OF_USE_DIALOGUE_OPEN] = (validInput, dispatch, getState) => { dispatch({ type: SET_TERMS_OF_USE_DIALOGUE_OPEN, payload: validInput}); };
Thunks[SET_DELETE_CONTACT_DIALOGUE_OPEN] = (validInput, dispatch, getState) => { dispatch({ type: SET_DELETE_CONTACT_DIALOGUE_OPEN, payload: validInput}); };
Thunks[SET_PROJECT_CONTACTS_DIALOGUE_ID] = (validInput, dispatch, getState) => { dispatch({ type: SET_PROJECT_CONTACTS_DIALOGUE_ID, payload: validInput}); };
Thunks[SET_WELCOME_DIALOGUE_OPEN] = (validInput, dispatch, getState) => { dispatch({ type: SET_WELCOME_DIALOGUE_OPEN, payload: validInput}); };
Thunks[SET_LAST_VIEWED_PROJECT] = (validInput, dispatch, getState) => { dispatch({ type: SET_LAST_VIEWED_PROJECT, payload: validInput}); };
Thunks[SET_FEEDBACK_DIALOGUE_OPEN] = (validInput, dispatch, getState) => { dispatch({ type: SET_FEEDBACK_DIALOGUE_OPEN, payload: validInput}); };
Thunks[SET_ADMIN_DIALOGUE_OPEN] = (validInput, dispatch, getState) => { dispatch({ type: SET_ADMIN_DIALOGUE_OPEN, payload: validInput}); };
Thunks[SET_UNREAD_MESSAGES_DIALOGUE_OPEN] = (validInput, dispatch, getState) => { dispatch({ type: SET_UNREAD_MESSAGES_DIALOGUE_OPEN, payload: validInput}); };
Thunks[SET_USER_ROLE_INFO_DIALOGUE_SHOWING] = (validInput, dispatch, getState) => { dispatch({ type: SET_USER_ROLE_INFO_DIALOGUE_SHOWING, payload: validInput}); };
Thunks[SET_USING_INVITE_LINK] = (validInput, dispatch, getState) => { dispatch({ type: SET_USING_INVITE_LINK, payload: validInput}); };
Thunks[STOP_USING_INVITE_LINK] = (validInput, dispatch, getState) => { dispatch({ type: STOP_USING_INVITE_LINK, payload: validInput}); };
Thunks[SET_USING_UNSUBSCRIBE_SUBSCRIPTION_CONTACT_LINK] = (validInput, dispatch, getState) => { dispatch({ type: SET_USING_UNSUBSCRIBE_SUBSCRIPTION_CONTACT_LINK, payload: validInput}); };
Thunks[STOP_USING_UNSUBSCRIBE_SCHEDULE_CONTACT_LINK] = (validInput, dispatch, getState) => { dispatch({ type: STOP_USING_UNSUBSCRIBE_SCHEDULE_CONTACT_LINK, payload: validInput}); };
Thunks[SET_USING_INVITE_SUBSCRIPTION_CONTACT_LINK] = (validInput, dispatch, getState) => { dispatch({ type: SET_USING_INVITE_SUBSCRIPTION_CONTACT_LINK, payload: validInput}); };
Thunks[STOP_USING_INVITE_SCHEDULE_CONTACT_LINK] = (validInput, dispatch, getState) => { dispatch({ type: STOP_USING_INVITE_SCHEDULE_CONTACT_LINK, payload: validInput}); };
Thunks[SET_UPGRADE_TO_STANDARD_DIALOGUE_OPEN] = (validInput, dispatch, getState) => { dispatch({ type: SET_UPGRADE_TO_STANDARD_DIALOGUE_OPEN, payload: validInput}); };
Thunks[SET_EDIT_SUBSCRIPTION_MANAGERS_DIALOGUE_OPEN] = (validInput, dispatch, getState) => { dispatch({ type: SET_EDIT_SUBSCRIPTION_MANAGERS_DIALOGUE_OPEN, payload: validInput}); };
Thunks[SET_SUBSCRIPTION_CHOOSER_DIALOGUE_OPEN] = (validInput, dispatch, getState) => { dispatch({ type: SET_SUBSCRIPTION_CHOOSER_DIALOGUE_OPEN, payload: validInput}); };
Thunks[SET_IS_TOUCH_DEVICE] = (validInput, dispatch, getState) => { dispatch({ type: SET_IS_TOUCH_DEVICE, payload: validInput}); };
Thunks[SET_EDIT_DAILY_REPORT_DIALOGUE_ID] = (validInput, dispatch, getState) => { dispatch({ type: SET_EDIT_DAILY_REPORT_DIALOGUE_ID, payload: validInput}); };
Thunks[SET_PATH] = (validInput, dispatch, getState, onSuccess) => { dispatch(setPath(validInput.path)); };
Thunks[SET_ALERT] = (validInput, dispatch, getState, onSuccess) => { dispatch({ type: SET_ALERT, payload: validInput.message }); };
Thunks[SET_LOADING] = (validInput, dispatch, getState, onSuccess) => { dispatch({ type: SET_LOADING, payload: validInput }); };
Thunks[ADD_UNREAD_SCHEDULE_MESSAGE_THREAD] = (validInput, dispatch, getState, onSuccess) => { dispatch({ type: ADD_UNREAD_SCHEDULE_MESSAGE_THREAD, payload: validInput }); };
Thunks[ADD_ALL_UNREAD_SCHEDULE_MESSAGE_THREADS] = (validInput, dispatch, getState, onSuccess) => { dispatch({ type: ADD_ALL_UNREAD_SCHEDULE_MESSAGE_THREADS, payload: validInput }); };
Thunks[ADD_ALL_SUBSCRIPTIONS] = (validInput, dispatch, getState, onSuccess) => { dispatch({ type: ADD_ALL_SUBSCRIPTIONS, payload: validInput }); };
Thunks[SET_JOINED_SUBSCRIPTION_DIALOGUE_SHOWING] = (validInput, dispatch, getState) => { dispatch({ type: SET_JOINED_SUBSCRIPTION_DIALOGUE_SHOWING, payload: validInput}); };
Thunks[SETUP_LOCAL_SESSION] = (validInput, dispatch, getState, onSuccess) => { dispatch({ type: SETUP_LOCAL_SESSION, payload: validInput, }); }
Thunks[SET_SHARE_LINK_DIALOGUE_SHOWING] = (validInput, dispatch, getState, onSuccess) => { dispatch({ type: SET_SHARE_LINK_DIALOGUE_SHOWING, payload: validInput, }); }
Thunks[SET_USING_SHARE_SCHEDULE_LINK] = (validInput, dispatch, getState) => { dispatch({ type: SET_USING_SHARE_SCHEDULE_LINK, payload: validInput}); };
Thunks[SET_EDIT_SCHEDULE_DIALOGUE_SHOWING] = (validInput, dispatch, getState) => { dispatch({ type: SET_EDIT_SCHEDULE_DIALOGUE_SHOWING, payload: validInput}); };
Thunks[SET_REQUEST_SCHEDULE_EMAIL_UPDATES_DIALOGUE_OPEN]=(validInput, dispatch, getState)=>{ dispatch({ type: SET_REQUEST_SCHEDULE_EMAIL_UPDATES_DIALOGUE_OPEN, payload: validInput}); };
Thunks[SET_CONFIRM_SHARE_SCHEDULE_WORK_DATES_DIALOGUE_OPEN]=(validInput, dispatch, getState)=>{ dispatch({ type: SET_CONFIRM_SHARE_SCHEDULE_WORK_DATES_DIALOGUE_OPEN, payload: validInput}); };
Thunks[SET_SHARE_SCHEDULE_CONFIRMED]=(validInput, dispatch, getState)=>{ dispatch({ type: SET_SHARE_SCHEDULE_CONFIRMED, payload: validInput}); };
Thunks[SET_REVIEW_SHARED_SCHEDULE_VIEWS_DIALOGUE_OPEN]=(validInput, dispatch, getState)=>{ dispatch({ type: SET_REVIEW_SHARED_SCHEDULE_VIEWS_DIALOGUE_OPEN, payload: validInput}); };
Thunks[SET_REVIEW_SHARED_SCHEDULE_CONFIRMATIONS_DIALOGUE_OPEN]=(validInput, dispatch, getState)=>{ dispatch({ type: SET_REVIEW_SHARED_SCHEDULE_CONFIRMATIONS_DIALOGUE_OPEN, payload: validInput}); };
Thunks[SET_DELETE_PROMO_CODE_DIALOGUE_OPEN]=(validInput, dispatch, getState)=>{ dispatch({ type: SET_DELETE_PROMO_CODE_DIALOGUE_OPEN, payload: validInput}); };
Thunks[SET_NOTE_PROMO_CODE_DIALOGUE_OPEN]=(validInput, dispatch, getState)=>{ dispatch({ type: SET_NOTE_PROMO_CODE_DIALOGUE_OPEN, payload: validInput}); };
Thunks[SET_EXPIRATION_PROMO_CODE_DIALOGUE_OPEN]=(validInput, dispatch, getState)=>{ dispatch({ type: SET_EXPIRATION_PROMO_CODE_DIALOGUE_OPEN, payload: validInput}); };
Thunks[SET_USING_PROMO_SIGNUP_LINK]=(validInput, dispatch, getState)=>{ dispatch({ type: SET_USING_PROMO_SIGNUP_LINK, payload: validInput}); };
Thunks[STOP_USING_PROMO_SIGNUP_LINK]=(validInput, dispatch, getState)=>{ dispatch({ type: STOP_USING_PROMO_SIGNUP_LINK, payload: validInput}); };
Thunks[SET_PREFERS_PROJECTS_LIST_VIEW]=(validInput, dispatch, getState)=>{ dispatch({ type: SET_PREFERS_PROJECTS_LIST_VIEW, payload: validInput}); };
Thunks[SET_SCHEDULE_UNLOCKED_CONFIRMATION_SHOWING]=(validInput, dispatch, getState)=>{ dispatch({ type: SET_SCHEDULE_UNLOCKED_CONFIRMATION_SHOWING, payload: validInput}); };
Thunks[SET_SCHEDULE_PUBLISHED_CONFIRMATION_SHOWING]=(validInput, dispatch, getState)=>{ dispatch({ type: SET_SCHEDULE_PUBLISHED_CONFIRMATION_SHOWING, payload: validInput}); };

const WebsocketThunks = {};
WebsocketThunks[SET_NAME] = { loadingMessage: 'Updating name', };
WebsocketThunks[ADD_PROJECT] = { loadingMessage: 'Creating Project', };
WebsocketThunks[EDIT_PROJECT] = { loadingMessage: 'Updating Project', };
WebsocketThunks[DELETE_PROJECT] = { loadingMessage: 'Deleting Project', };
WebsocketThunks[ADD_PROJECT_MEMBER] = { loadingMessage: 'Adding Project Member', };
WebsocketThunks[CHANGE_PROJECT_MEMBER_ROLE] = { loadingMessage: 'Updating Project Member', };
WebsocketThunks[CHANGE_PENDING_PROJECT_MEMBER_ROLE] = { loadingMessage: 'Updating Project Member', };
WebsocketThunks[REMOVE_PROJECT_MEMBER] = { loadingMessage: 'Removing Project Member', };
WebsocketThunks[REMOVE_PENDING_PROJECT_MEMBER] = { loadingMessage: 'Removing Project Member', };
WebsocketThunks[ADD_SCHEDULE] = { loadingMessage: 'Creating Schedule', };
WebsocketThunks[UNPUBLISH_SCHEDULE] = { loadingMessage: 'Unlocking Schedule', };
WebsocketThunks[ADD_SCHEDULE_MESSAGE_THREAD] = { loadingMessage: 'Creating Schedule Message Thread', };
WebsocketThunks[ENTER_SCHEDULE_MESSAGE_THREAD] = {};
WebsocketThunks[LEAVE_SCHEDULE_MESSAGE_THREAD] = {};
WebsocketThunks[ADD_SCHEDULE_MESSAGE] = { loadingMessage: 'Sending Message', };
//WebsocketThunks[ADD_ACTIVITY] = { loadingMessage: 'Adding Activity', };
WebsocketThunks[ADD_DAILY_REPORT] = { loadingMessage: 'Creating Daily Report', };
WebsocketThunks[DELETE_DAILY_REPORT] = { loadingMessage: 'Deleting Daily Report', };
WebsocketThunks[CREATE_TRIAL_SUBSCRIPTION] = { loadingMessage: 'Activating Your Trial Subscription', };
WebsocketThunks[CREATE_STANDARD_SUBSCRIPTION_CHECKOUT] = { loadingMessage: 'Starting Standard Subscription Checkout', };
WebsocketThunks[CANCEL_PENDING_STANDARD_SUBSCRIPTION] = {};
WebsocketThunks[CREATE_STRIPE_PORTAL_SESSION] = { loadingMessage: 'Opening Subscription Management', };
WebsocketThunks[SUBMIT_FEEDBACK] = { loadingMessage: 'Sending Feedback', };
WebsocketThunks[SEND_EMAIL] = { loadingMessage: 'Sending Email', };
WebsocketThunks[SET_PROJECT_CONTRACTORS] = { loadingMessage: 'Setting Project Contractors', };
WebsocketThunks[SET_STARTUP_WELCOME_ENABLED] = {};
WebsocketThunks[ADD_SUBSCRIPTION_ADMIN] = { loadingMessage: 'Adding Account Manager', };
WebsocketThunks[REMOVE_SUBSCRIPTION_ADMIN] = { loadingMessage: 'Removing Account Manager', };
WebsocketThunks[REMOVE_PENDING_SUBSCRIPTION_ADMIN] = { loadingMessage: 'Removing Account Manager', };
WebsocketThunks[ACCEPT_SUBSCRIPTION_INVITE] = { loadingMessage: 'Joining Subscription', };
WebsocketThunks[REJECT_SUBSCRIPTION_INVITE] = { loadingMessage: 'Rejecting Subscription Invite', };
WebsocketThunks[ADD_PROJECT_SCHEDULE_CONTACTS] = { loadingMessage: 'Adding Contacts', };
WebsocketThunks[DELETE_PROJECT_SCHEDULE_CONTACT] = { loadingMessage: 'Removing Contact', };
WebsocketThunks[GET_SHARE_SCHEDULE_LINK] = {};
WebsocketThunks[PROMO_CODE_CREATE] = { loadingMessage: 'Creating Promo Code', };
WebsocketThunks[PROMO_CODE_DELETE] = { loadingMessage: 'Deleting Promo Code', };
WebsocketThunks[PROMO_CODE_SET_NOTE] = { loadingMessage: 'Updating Promo Code', };
WebsocketThunks[PROMO_CODE_SET_EXPIRATION] = { loadingMessage: 'Updating Promo Code', };
WebsocketThunks[PROMO_CODE_SET_DISABLED] = { loadingMessage: 'Expiring Promo Code', };

const FetchDataThunks = {};
FetchDataThunks[GET_SCHEDULE] = { getDataKey: (validInput) => {
  return validInput.type + '#scheduleId#' + validInput.scheduleId;
}};
FetchDataThunks[GET_SCHEDULE_MESSAGES] = { getDataKey: (validInput) => {
  return validInput.type + '#scheduleMessageThreadId#' + validInput.scheduleMessageThreadId + '#fetchBeforeTimestamp#' + validInput.fetchBeforeTimestamp;
}};
FetchDataThunks[GET_SCHEDULE_MESSAGE_THREADS] = { getDataKey: (validInput) => {
  return validInput.type + '#projectId#' + validInput.projectId;
}};
FetchDataThunks[GET_PROJECT_CONTRACTORS] = { getDataKey: (validInput) => {
  return validInput.type + '#projectId#' + validInput.projectId;
}};
FetchDataThunks[GET_DAILY_REPORT] = { getDataKey: (validInput) => {
  return validInput.type + '#dailyReportId#' + validInput.dailyReportId;
}};
FetchDataThunks[GET_DAILY_REPORT_SUMMARIES] = { getDataKey: (validInput) => {
  return validInput.type + '#projectId#' + validInput.projectId;
}};
FetchDataThunks[GET_SUBSCRIPTION_INVITES] = { getDataKey: (validInput) => {
  return validInput.type;
}};
FetchDataThunks[GET_PROJECT_SCHEDULE_CONTACTS] = { getDataKey: (validInput) => {
  return validInput.type + '#projectId#' + validInput.projectId;
}};
FetchDataThunks[GET_CONTACT_SHARED_SCHEDULE_STATS] = { getDataKey: (validInput) => {
  return validInput.type + '#scheduleId#' + validInput.scheduleId;
}};
FetchDataThunks[PROMO_CODE_FETCH_ALL] = { getDataKey: (validInput) => {
  return validInput.type;
}};

export const siteboardAction = (type, params, onSuccess, onFailure) => (dispatch, getState) => {
  try {
    if(!(type in SiteboardApiValidator)) throw new Error('Could not find validator for ' + type);
    if(!isObject(params)) throw new Error('Please provide parameters for ' + type + ' in a valid format');

    const validInput = SiteboardApiValidator[type].validateInput({
      ...params, 
      type: type, 
      action: type, 
      userId: UUID.isValid(params.userId) ? params.userId : (getState().localPersistent.isLoggedIn === true ? getState().localPersistent.userId : getState().serverSynced.userId),
      sessionKey: getState().localPersistent.sessionKey,
    });

    if(type in WebsocketThunks) {
      if(getState().serverSynced.localOnlyMode === true) {
        dispatch({ type: validInput.type, payload: validInput, });
        setTimeout(() => {
          try { onSuccess(validInput); } catch(error) {}
        }, 1);
      } else {
        const thunk = WebsocketThunks[type];
        if(typeof thunk.loadingMessage === 'string' && thunk.loadingMessage.length > 0) {
          dispatch(setLoading(thunk.loadingMessage));
        }
        const onApiSuccess = (message) => {
          try {
            if(typeof thunk.loadingMessage === 'string' && thunk.loadingMessage.length > 0) {
              dispatch(setLoading('')); 
            }
            const validOutput = SiteboardApiValidator[type].validateOutput(message);
            dispatch({ type: type, payload: validOutput });
            try { onSuccess(validOutput); } catch(error) {}
          } catch(error) {
            onApiError({payload: error.message});
          }
        };
        const onApiError = (message) => {
          if(typeof thunk.loadingMessage === 'string' && thunk.loadingMessage.length > 0) {
            dispatch(setLoading('')); 
            dispatch(setAlert(isObject(message) && typeof message.payload === 'string' && message.payload.length > 0 ? message.payload : ('Error ' + thunk.loadingMessage)));
          }
        };
        websocket.send(validInput, onApiSuccess, onApiError);
      }
    } else if(type in FetchDataThunks) {
      const thunk = FetchDataThunks[type];
      const dataKey = thunk.getDataKey(validInput);

      // Exit if we already made this request or it is in progress
      if(dataKey in getState().localEphemeral.pendingDataRequests) {
        FetchDataThunks[type].pendingSuccessCallbacks = [...(FetchDataThunks[type].pendingSuccessCallbacks || []), onSuccess];
        FetchDataThunks[type].pendingFailureCallbacks = [...(FetchDataThunks[type].pendingFailureCallbacks || []), onFailure];
        return dataKey;
      }
      if(dataKey in getState().localEphemeral.completedDataRequests) {
        try { onSuccess(); } catch(error) {}
        return dataKey;
      }

      dispatch({ type: FETCH_DATA_PENDING, payload: dataKey });
      const onApiSuccess = (message) => {
        try {
          const validOutput = SiteboardApiValidator[type].validateOutput(message);
          dispatch({ type: type, payload: validOutput });
          dispatch({ type: FETCH_DATA_COMPLETE, payload: dataKey });
          try { onSuccess(); } catch(error) {}
          for(const pendingSuccessCallback of (FetchDataThunks[type].pendingSuccessCallbacks || [])) {
            try { pendingSuccessCallback(); } catch(error) {}
          }
          delete FetchDataThunks[type].pendingSuccessCallbacks;
        } catch(error) {
          debugLog(error);
          onApiError({payload: error.message});
        }
      };
      const onApiError = (message) => {
        dispatch({ type: FETCH_DATA_FAIL, payload: dataKey });
        try { onFailure(message.payload); } catch(error) {}
        for(const pendingFailureCallback of (FetchDataThunks[type].pendingFailureCallbacks || [])) {
          try { pendingFailureCallback(message.payload); } catch(error) {}
        }
        delete FetchDataThunks[type].pendingFailureCallbacks;
      };
      websocket.send(validInput, onApiSuccess, onApiError);
      return dataKey;
    } else if(type in Thunks) {
      return Thunks[type](validInput, dispatch, getState, onSuccess);
    } else {
      throw new Error('Unsupported action: ' + type);
    }
  } catch(error) {
    dispatch(setAlert(''+error));
    // TODO: maybe send these errors to the server
  }
};

export const saveStateToLocalStorage = (state) => {
  try {
    // only save part of the state to local storage
    const stateToSave = {
      ...(isObject(state.localPersistent) ? {'localPersistent': state.localPersistent} : {} ),
    };
    const serializedState = JSON.stringify(stateToSave);
    localStorage.setItem('siteboard#v1', serializedState);
  } catch(error) {
    debugLog('error saving store state to localStorage:', error);
  }
};

export const loadStateFromLocalStorage = () => {
  try {
    const serializedState = localStorage.getItem('siteboard#v1'); // siteboardState
    let state = serializedState === null ? {} : JSON.parse(serializedState);
    if(!isObject(state)) { state = {}; }

    if(!isObject(state.localPersistent)) { state.localPersistent = {}; }
    if(!UUID.isValid(state.localPersistent.userId)) { state.localPersistent.userId = ''; }
    if(!SessionKey.isValid(state.localPersistent.sessionKey)) { state.localPersistent.sessionKey = ''; }
    state.localPersistent.isLoggedIn = state.localPersistent.isLoggedIn === true && UUID.isValid(state.localPersistent.userId) && SessionKey.isValid(state.localPersistent.sessionKey);
    if(typeof state.localPersistent.path !== 'string') { state.localPersistent.path = ''; }
    if(typeof state.localPersistent.lastViewedProjectId !== 'string') { state.localPersistent.lastViewedProjectId = '00000000-0000-0000-0000-000000000000'; }
    if(typeof state.localPersistent.prefersProjectsListView !== 'boolean') { state.localPersistent.prefersProjectsListView = false; }

    // legacy state storage
    //const serializedState = localStorage.getItem('siteboardState');
    //if(!isObject(state.defaultRed)) { state.defaultRed = {}; }
    //if(typeof state.defaultRed.name !== 'string') { state.defaultRed.name = ''; }
    //if(typeof state.defaultRed.email !== 'string') { state.defaultRed.email = ''; }
    //if(typeof state.defaultRed.userId !== 'string') { state.defaultRed.userId = ''; }
    //if(typeof state.defaultRed.sessionKey !== 'string') { state.defaultRed.sessionKey = ''; }
    //if(typeof state.defaultRed.isLoggedIn !== 'boolean') { state.defaultRed.isLoggedIn = false; }
    //if(typeof state.defaultRed.path !== 'string') { state.defaultRed.path = ''; }
    //if(!isArray(state.defaultRed.projects)) { state.defaultRed.projects = []; }
    //if(!isArray(state.defaultRed.schedules)) { state.defaultRed.schedules = []; }
    //if(!isArray(state.defaultRed.activities)) { state.defaultRed.activities = []; }
    //if(!isArray(state.defaultRed.messages)) { state.defaultRed.messages = []; }
    //state.defaultRed.loadingMessage = ''; // clear existing loading messsage on load
    //state.defaultRed.alertMessage = ''; // clear existing alert messsage on load

    return state;
  } catch(error) {
    debugLog('error loading redux state from local storage:', error);
  }
  return {};
};
